import { render, staticRenderFns } from "./AdminDetaljiKorisnika.vue?vue&type=template&id=f65eecf0&"
import script from "./AdminDetaljiKorisnika.vue?vue&type=script&lang=js&"
export * from "./AdminDetaljiKorisnika.vue?vue&type=script&lang=js&"
import style0 from "./AdminDetaljiKorisnika.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports